import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Input } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { TransportCreationProfile } from '../../../../../client/model/station-usage.model';
import { CRequestVehicleToStationByTransportCreationProfile as RequestVehicleToStationByTransportCreationProfile } from '../../model/action-tablet.model';

import { ResponseMessage, ServiceResponse } from '@sdbn/common';

@Component({
  selector: 'app-action-tablet-transport-creation-profile-details',
  templateUrl: './action-tablet-transport-creation-profile-details.component.html',
  styleUrls: ['./action-tablet-transport-creation-profile-details.component.scss']
})
export class ActionTabletTransportCreationProfileDetailsComponent {

  isLoading = false;
  responseMessages: ResponseMessage[];

  @Input() stationId: number;
  @Input() transportCreationProfile: TransportCreationProfile;

  constructor(
    private appServerAPI: AppServerAPI,
    private tmcContextService: TmcContextService
  ) { }

  public createPlannedTransportFromProfile() {
    if (this.isLoading) {
      return;
    }

    const dto = new RequestVehicleToStationByTransportCreationProfile();
    dto.transportCreationProfileId = this.transportCreationProfile.id;
    dto.targetStationId = this.stationId;
    this.isLoading = true;
    this.appServerAPI.execute<ServiceResponse>('/client/control/action-tablet/request-vehicle-by-transport-creation-profile', dto).subscribe(response => {
      this.responseMessages = response.responseMessages;
      this.tmcContextService.forceRefreshOfStationUsages();
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    })
  }
}
